import React, { useEffect, useState } from "react";
import {
  MainHeader,
  TitleSection,
  MainHeaderBtnContainer,
  ImgWrapper,
} from "./index.styled";
import { TextContainer } from "./index.styled";
import { CustomButton } from "../buttons/index.styled";
import dashedVector from "../../assets/images/dashedVector.png";
import audioImg from "../../assets/images/Audio.svg";
import { env } from "../../.env";

const MainTitle = () => {
  const [typing, setTyping] = useState(" ");

  useEffect(() => {
    const text = "به راحتی متن فارسی را به گفتار روان تبدیل کنید..";

    let index = 0;

    let typing = true;

    let editedText = "";

    setInterval(() => {
      if (text[index] && typing) {
        editedText = editedText + text[index];
        index++;
      } else {
        typing = false;
        editedText = editedText.slice(0, -1);
        index = 0;
        if (!editedText) {
          typing = true;
        }
      }
      setTyping(editedText);
    }, 220);
  }, []);

  return (
    <MainHeader className="container">
      <TitleSection>
        <h2>آواشو</h2>
        <form>
          <input type="text" placeholder={typing} disabled />
        </form>
        <TextContainer textBreak={true}>
          <p>
            با آواشو در هرکجا که باشید، می‌توانید به بهترین شکل ممکن و با کمترین
            هزینه متن‌ها را به گفتار تبدیل کنید. این متن‌ها می‌توانند سخنرانی
            مجازی، خواندن خبر و یا حتی یک اعلان عمومی ساده باشند.{" "}
          </p>
        </TextContainer>
        <MainHeaderBtnContainer>
          <a href={env.REACT_APP_PANEL_REDIRECT}>
            <CustomButton width="200px" height="48px" radius="12px">
              درخواست دمو
            </CustomButton>
          </a>
          <img src={audioImg} />
        </MainHeaderBtnContainer>
      </TitleSection>
      <ImgWrapper>
        <img src={dashedVector} alt="banner" />
      </ImgWrapper>
    </MainHeader>
  );
};

export default MainTitle;
